import { Node, Edge, getOutgoers } from "@xyflow/react";

/** This helps us create the correct new edges when there are multiple nodes being deleted via multi-select */
export default function getFarthestNonDeletedOutgoers(
  node: Node,
  nodes: Node[],
  edges: Edge[],
  nodesDeletedIds: string[],
): Node[] {
  const outgoers = getOutgoers(node, nodes, edges);

  const areAllOutgoersDeleted = outgoers.every((outgoer) =>
    nodesDeletedIds.includes(outgoer.id),
  );

  if (areAllOutgoersDeleted) {
    // If all outgoers are deleted, look at the outgoers' outgoers
    const farthestOutgoers = [];
    for (const outgoer of outgoers) {
      // Get the outgoers of the deleted outgoer
      const nextLevelOutgoers = getFarthestNonDeletedOutgoers(
        outgoer,
        nodes,
        edges,
        nodesDeletedIds,
      );
      farthestOutgoers.push(...nextLevelOutgoers);
    }
    return farthestOutgoers;
  } else {
    return outgoers;
  }
}
